var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { adoptedStyle, customElement } from '@mantou/gem/lib/decorators';
import { createCSSSheet, css } from '@mantou/gem/lib/utils';
import { DuoyunModalElement } from './modal';
const style = createCSSSheet(css `
  .dialog {
    top: 0;
    left: auto;
    right: 0;
    height: 100%;
  }
  .main {
    padding: 1.2em;
    min-width: 30em;
    min-height: none;
    max-height: none;
    border-radius: 0;
  }
  @keyframes showDialog {
    0% {
      transform: translate(100%, 0);
    }
    100% {
      transform: translate(0);
    }
  }
`);
/**
 * @customElement dy-drawer
 */
let DuoyunDrawerElement = class DuoyunDrawerElement extends DuoyunModalElement {
    constructor(options) {
        super(options);
        this.addEventListener('maskclick', () => this.close(null));
    }
};
DuoyunDrawerElement = __decorate([
    customElement('dy-drawer'),
    adoptedStyle(style)
], DuoyunDrawerElement);
export { DuoyunDrawerElement };
export const Drawer = DuoyunDrawerElement;
//# sourceMappingURL=drawer.js.map